import { Controller } from "@hotwired/stimulus"

// Toggles the off-canvas sidebar on small screens by flipping
// <html data-sidebar-open="true|false">, which the layout uses to slide the panel.
export default class extends Controller {
  connect() {
    // On mobile the drawer overlays the content, so close it whenever the user navigates
    // (tapping a category/link) — otherwise it stays open covering the page just opened.
    this._closeOnNav = () => this.close()
    document.addEventListener("turbo:visit", this._closeOnNav)
  }

  disconnect() {
    document.removeEventListener("turbo:visit", this._closeOnNav)
  }

  toggle() {
    const html = document.documentElement
    const open = html.dataset.sidebarOpen === "true"
    html.dataset.sidebarOpen = open ? "false" : "true"
  }

  close() {
    document.documentElement.dataset.sidebarOpen = "false"
  }
}
